import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createApi } from "@reduxjs/toolkit/query/react";
import { apiBaseQuery } from "../common/utils/apiBaseQuery";
import { PersonInfoInterface } from "../common/interfaces/PersonInfoInterface";

export interface RootInterface {
    authToken?: string;
    personInfo?: PersonInfoInterface;
}

const initialState: RootInterface = {
    authToken: undefined,
};

export const rootSlice = createSlice({
    name: "root",
    initialState,
    reducers: {
        setAuthToken: (state, action: PayloadAction<string>) => {
            state.authToken = action.payload;
        },
        setPersonInfo: (
            state,
            action: PayloadAction<RootInterface["personInfo"]>,
        ) => {
            state.personInfo = action.payload;
        },
    },
});

export const rootApiSlice = createApi({
    reducerPath: "rootApi",
    baseQuery: apiBaseQuery(),
    tagTypes: [],
    endpoints: () => ({}),
});

export const { setAuthToken, setPersonInfo } = rootSlice.actions;

export default rootSlice.reducer;
